import { useState, useEffect } from "react";

const useTokenRole = () => {
  const [role, setRole] = useState<any | null>(null);

  useEffect(() => {
    const token = localStorage.getItem("token"); // Retrieve the token from local storage
    if (token) {
      try {
        // Split the token into its parts (header, payload, signature)
        const [, payload] = token.split(".");
        if (payload) {
          // Decode the Base64 payload
          const decodedPayload = JSON.parse(atob(payload));
          setRole(decodedPayload.scope); // Extract the role from the decoded payload
        }
      } catch (error) {
        console.error("Failed to decode token:", error);
        setRole(null);
      }
    }
  }, []);

  return role;
};

export default useTokenRole;